import { createEvent } from "effector";
import axios from "axios";
export var SessionUserPermission;
(function (SessionUserPermission) {
    SessionUserPermission[SessionUserPermission["ReadOnly"] = 0] = "ReadOnly";
    SessionUserPermission[SessionUserPermission["All"] = 1] = "All";
})(SessionUserPermission || (SessionUserPermission = {}));
export var sessionTimeout = createEvent();
export var isSessionTimeoutError = function (error) {
    var _a;
    if (axios.isAxiosError(error)) {
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            return true;
        }
    }
    return false;
};
